/* eslint-disable @typescript-eslint/no-magic-numbers */
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';

import { Observable, Subject, Subscription } from 'rxjs';
import { QUARA_MAX_INSTALLMENTS } from '../quara-promo/quara-promo.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoadingComponent } from '@app/shared/components/loading/loading.component';
import { QuaraIconIconComponent } from '@app/shared/components/icons/generated/quara-icon/quara-icon.component';
import { AkitaRouterQuery } from '@app/akita/router/state/router.query';

@Component({
  selector: 'popsy-quara-overview',
  templateUrl: './quara-overview.template.html',
  styleUrls: ['./quara-overview.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslocoModule,
    LoadingComponent,
    QuaraIconIconComponent,
  ],
})
export class QuaraOverviewComponent implements OnDestroy, OnChanges {
  @Input() public listingId?: string | null;
  @Input() public amount?: number | null;
  @Input() public currency?: string | null;

  public maxInstallments: number | null;
  public splitAmount: string | null;

  public rtl$: Observable<boolean>;

  public readonly language$: Observable<string>;

  private readonly subscriptions: Subscription;
  private readonly destroySubject: Subject<void>;

  constructor(
    private readonly translateService: TranslocoService,
    private readonly akitaRouterQuery: AkitaRouterQuery
  ) {
    // private readonly quaraActionsService: QuaraActionsService,

    this.destroySubject = new Subject();
    this.subscriptions = new Subscription();

    this.language$ = this.translateService.langChanges$;
    this.rtl$ = this.akitaRouterQuery.selectIsRtlLayout();

    this.splitAmount = ((this.amount || 0) / QUARA_MAX_INSTALLMENTS).toFixed(2);

    this.maxInstallments = QUARA_MAX_INSTALLMENTS;
  }
  public ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.splitAmount = ((this.amount || 0) / QUARA_MAX_INSTALLMENTS).toFixed(2);
    }
  }

  public ngOnDestroy(): void {
    this.destroySubject.next();
    this.destroySubject.complete();

    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
